/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Group</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Group</label>
                        <input type="text" ref="group" id="" class="form-control mb-4">
                    </div>
                    
                    <div class="form-group col-md-6">
                        <label>Teacher</label>
                        <select class="form-control mb-4" v-model="teacher">
                            <option selected disabled>-- Select A Teacher --</option>
                            <option
                              v-for="teacher in teachers"
                              :key="teacher._id"
                              v-bind:value="teacher._id"
                            >
                              {{ teacher.first_name }}
                            </option>
                          </select>
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addGroup()">Add Group</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddGroup',
    components: {

    },
    data() {
        return {
            teachers: [],
            teacher: "",
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addGroup() {

            let data = {
                group: this.$refs.group.value,
                teacher_id: this.teacher,
                teacher_name: ''
            }

            if(!data.group) {
                this.$toast.open({
                    message: "Error: Please input group number",
                    type: 'error'
                });
                return;
            }


            if(data.teacher_id == "") {
                this.$toast.open({
                    message: "Error: Please select a teacher",
                    type: 'error'
                });
                return;
            }


            data.teacher_name = this.teachers.filter((teacher) => teacher._id == this.teacher)[0].first_name;

            this.teacher = "";
            this.$refs.group.value = "";
            
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Creating Group Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/groups/create", data, config)

                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Group Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },
    mounted() {
        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                "Content-Type": "application/json",
            },
        };

        axios
        .get(this.$apiURI + "/account/teachers", config)
        .then((response) => {
            if (response.data.error) {
            this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
            });
            } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            this.teachers = response.data.data.teachers;
            }
        })
        .catch((error) => {
            this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
            });
        });
    }
}
</script>
